import React, { Component } from 'react';
import ResetView from './resetView';
import api from '../../../utils/api';
import apiResponseMessage from '../../../utils/apiResponse';

class ResetComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            success: false,
            message: null,
            password: null,
            passwordAgain: null,
        };
    }

    handleReset = async (event) => {
        event.preventDefault();

        let memberId = this.props.match.params.id;
        let token = this.props.match.params.token;
        let password = this.state.password;
        let passwordAgain = this.state.passwordAgain;
        const data = {
            memberId,
            token,
            password,
            passwordAgain,
        };
        try {
            const response = await api.post('/reset', data, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            this.setState({
                ...this.state,
                ...{
                    success: response.data.success,
                    message: apiResponseMessage(response.data),
                },
            });
        } catch (e) {
            this.setState({
                ...this.state,
                ...{
                    success: false,
                    message:
                        apiResponseMessage(e?.response?.data, 'reset.requestFailed'),
                },
            });
        }
    };

    handleInputChange = (event) => {
        const target = event.target;
        const value =
            target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value,
        });
    };

    matchPassword = (value) => {
        return value && value === this.state.password;
    };

    render() {
        const { success, message } = this.state;

        return (
            <ResetView
                success={success}
                message={message}
                handleInputChange={this.handleInputChange}
                handleReset={this.handleReset}
                matchPassword={this.matchPassword}
            />
        );
    }
}

export default ResetComponent;
